import {
  CLASSES_PATHNAME,
  MEDITATIONS_PATHNAME,
  BREATHWORK_PATHNAME,
  SERIES_PATHNAME,
  ARTICLES_PATHNAME,
  CHALLENGES_PATHNAME,
  COURSES_PATHNAME,
  LIBRARY_PATHNAME,
  PODCASTS_PATHNAME,
  POSES_PATHNAME,
  PREMIUM_TRAININGS_PATHNAME,
  TEACHERS_PATHNAME,
} from '~/src/common/routes';

function getPathnameRegExp(pathname: string): RegExp {
  return new RegExp(`^(/es)?${pathname}`, 'i');
}

const homepageRegExp = /^(\/es)?\/$/i;
const homepageWithRegexpRegExp = /^(\/es)?\/?\?.+$/i;
const loggedInHomepageRegExp = /^(\/es)?\/home\/$/i;

/**
 * we need to filter out some subpath of course pages:
 * - active course "player"
 * - "purchase"
 * */
const coursePageRegexp = /^(?!(\/es)?\/ecourse\/purchase)(\/es)?\/ecourse\/(player\/)?[^\/]+\/?$/i;

export const eligablePathsList = [
  homepageRegExp,
  homepageWithRegexpRegExp,
  loggedInHomepageRegExp,
  coursePageRegexp,
  getPathnameRegExp(CLASSES_PATHNAME),
  getPathnameRegExp(MEDITATIONS_PATHNAME),
  getPathnameRegExp(BREATHWORK_PATHNAME),
  getPathnameRegExp(SERIES_PATHNAME),
  getPathnameRegExp(ARTICLES_PATHNAME),
  getPathnameRegExp(CHALLENGES_PATHNAME),
  getPathnameRegExp(LIBRARY_PATHNAME),
  getPathnameRegExp(PODCASTS_PATHNAME),
  getPathnameRegExp(POSES_PATHNAME),
  getPathnameRegExp(PREMIUM_TRAININGS_PATHNAME),
  getPathnameRegExp(TEACHERS_PATHNAME),
  getPathnameRegExp(COURSES_PATHNAME),
  getPathnameRegExp('/meditation'),
  getPathnameRegExp('/class'),
  getPathnameRegExp('/article'),
  getPathnameRegExp('/profile'),
];
